import React from 'react';
import cn from 'classnames';
import ReactCountdown from 'react-countdown';
import * as labsUniStakeActions from '../../../../../../actions/labs-uni-stake-actions';
import styles from './intervals-table.module.scss';
import { useDispatch } from 'react-redux';

const Timer = ({ days, hours, minutes }) => {
  return (
    <div className={cn(styles.tableValue, styles.accent)}>
      <span>{days}D:</span>
      <span>{hours}H:</span>
      <span>{minutes}M</span>
    </div>
  );
};

const Countdown = ({ date }) => {
  const dispatch = useDispatch();
  return (
    <ReactCountdown
      date={date}
      renderer={(props) => <Timer {...props} />}
      onComplete={() =>
        setTimeout(() => {
          dispatch(labsUniStakeActions.getIntervalsTableData());
        }, 2000)
      }
    />
  );
};

export default Countdown;
